import styled from "styled-components";
import Input from "./Input";

const InputStyled = styled(Input)`
  display: flex;
  flex-direction: column;

  label {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.robotoBold};
  }

  input {
    background: transparent;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.colors.white};
    padding: 10px 20px;
    font-size: ${({ theme }) => theme.fontSizes.input};
    color: ${({ theme }) => theme.colors.grey};
    border-image-slice: 1 !important;
    border-width: 1px !important;
    border-image-source: linear-gradient(to left, #3d4253, #ffffff, #3d4253) !important;
  }

  .error {
    color: ${({ theme }) => theme.colors.red};
    font-family: ${({ theme }) => theme.fonts.robotoBold};
    height: 20px;
  }
`;

export default InputStyled;
